<div class="hds-overlay" (click)="close()">
  <div class="hds-dialog" role="alertdialog" aria-modal="true" [attr.aria-label]="title" (click)="$event.stopPropagation()">
    <div class="hds-b">
      <div class="hds-head">
        <span class="hds-ico">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
               stroke-linejoin="round"><path d="M3 6h18M8 6V4h8v2m-9 0l1 14h8l1-14"/></svg>
        </span>
        <div>
          <h3>{{title}}</h3>
          <p class="hds-sub">Tindakan ini tidak bisa dibatalkan.</p>
        </div>
      </div>

      <div class="hds-subject" *ngIf="subject">{{subject}}</div>

      <ul class="hds-effects" *ngIf="effects && effects.length">
        <li *ngFor="let e of effects">{{e}}</li>
      </ul>

      <label class="hds-type" *ngIf="confirmText">
        <span>Ketik <b>{{confirmText}}</b> untuk mengonfirmasi</span>
        <input type="text" [(ngModel)]="typed" [disabled]="busy" autocomplete="off" spellcheck="false"
               (keyup.enter)="submit()" autofocus>
      </label>
    </div>
    <div class="hds-foot hds-foot-end">
      <button type="button" class="vl-btn-ghost" [disabled]="busy" (click)="close()">Batal</button>
      <button type="button" class="hds-btn-danger" [disabled]="!canConfirm" (click)="submit()">
        <i class="fa fa-spinner fa-spin" *ngIf="busy"></i> {{actionLabel}}</button>
    </div>
  </div>
</div>
